/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_LabelInputs */



/**
* | output |
* | --- |
* | "Reasoning" |
*
* @param {Model_Settings_Reasoning_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_label = /** @type {((inputs?: Model_Settings_Reasoning_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Reasoning")
	return /** @type {LocalizedString} */ ("Reasoning")
});